import React from "react";
import classes from "./Attendance.module.scss";
import {  attendanceService } from "./AttendanceDuck";
import { useI18n } from "components/lni18n";
import { useAppDispatch } from "src/utils/ReduxHooks";

const RowDateRender = ({ value }) => {
    
    /** @type {import('redux').Dispatch<any>} */
    const dispatch = useAppDispatch();
    const { languageService: t } = useI18n();
    const deleteData = ()=>{
        dispatch( attendanceService.deleteMeetup(value.ClassId,  value.Id) );
    }


    return <div className={classes.dateCell}>
        {value.Dato}&nbsp;&nbsp;<button onClick={deleteData} type="button" className="btn btn-link">{t.getText("delete")}</button>
        <br />
        {value.Header}
    </div>

}

export default RowDateRender;